import { render, staticRenderFns } from "./SelectDoctorTemplate.vue?vue&type=template&id=2e5c5790&scoped=true&"
import script from "./SelectDoctorTemplate.vue?vue&type=script&lang=ts&"
export * from "./SelectDoctorTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SelectDoctorTemplate.vue?vue&type=style&index=0&id=2e5c5790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5c5790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
